import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';

const SSN_REGEX = /^\d{3}-\d{2}-\d{4}$/;

@Injectable({
    providedIn: 'root'
})
export class MemberService {

    authService: any ={};

    // private primarySSN: string ="";
    // private jointSSN: string ="";

    constructor(private commonService: CommonService,
        private httpClient: HttpClient
    ){
        var openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
        if (openIdTokenParams && openIdTokenParams.access_token) {
            this.authService.accessToken = openIdTokenParams.access_token;
        }
    }


    private handleError(error: Response){
        return Observable.throw(error.json());
    }


    checkMemberSubmit(): Observable<any>{
        return this.httpClient.get(this.commonService.baseUrl + `/api/member/check-member-submit`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);    //Rethrow it back to component
            })
          )
    }

    postUserSession(userSession): Observable<any>{
        return this.httpClient.post(this.commonService.baseUrl + `/api/userSession/post-session-item`, userSession)
    }

    checkIsHuman(token): Observable<any>{
        return this.httpClient.get(this.commonService.baseUrl + `/api/member/check-human/?captchaToken=${token}`)
    }


    // setUserSSN(role: 'primary' | 'joint', ssn: string) {
    //     if (ssn.match(SSN_REGEX)) {
    //         if (role === 'primary') {
    //             this.primarySSN = ssn;
    //         }
    //         else {
    //             this.jointSSN = ssn;
    //         }
    //     }
    // }
    
    // getUserSSN(role: 'primary' | 'joint'): string | null {
    //     return role === 'primary' ? this.primarySSN : this.jointSSN;
    // }
}